import { render, staticRenderFns } from "./TheDialerDetails.vue?vue&type=template&id=0e368dfe&"
import script from "./TheDialerDetails.vue?vue&type=script&lang=js&"
export * from "./TheDialerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports